<template>
    <div class="delivery" v-if="step === 0">
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/1/1.png" @click="goHistory"/>
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/1/2.png" />
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/pharmacy/1/3.png" />
            <div class="button1" @click="goDetail">
            
            </div>
            <div class="button2" @click="goQuestionnaire">
        
            </div>
            <div class="button3">
        
            </div>
            <div class="button4" @click="goMedicine">

            </div>
        </div>
        
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/1/4.png" />
        <img class="image bottom" src="../../assets/showcase/xi/detail/pharmacy/1/5.png" @click="() => step = 1"/>
    </div>
    <div class="delivery" v-else-if="step === 1">
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/2/1.png" @click="step = 0" />
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/2/2.png" />
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/2/3.png" @click="() => step = 2" />

    </div>
    <div class="delivery" v-else-if="step === 2">
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/3/1.png" @click="step = 1"/>
        <div class="bottom">
            <img class="image" src="../../assets/showcase/xi/detail/pharmacy/3/2.png" />
            <img class="image" src="../../assets/showcase/xi/detail/pharmacy/3/3.png" @click="() => step = 3"/>
        </div>

    </div>
    <div class="delivery" v-else-if="step === 3">
        <img class="image" src="../../assets/showcase/xi/detail/pharmacy/4/1.png" />
        <img class="image bottom" src="../../assets/showcase/xi/detail/pharmacy/4/2.png" @click="goDetail" />
    </div>
</template>

<script>
export default {
    name: 'deliveryPharmacy',
    data: function()
    {
        return {
            step: 0
        }
    },
    methods: {
        goDetail: function()
        {
            this.$emit('goDetailTab');
        },
        goQuestionnaire: function()
        {
            this.$emit('goQuestionnaireTab');
        },
        goMedicine: function()
        {
            this.$emit('goMedicineTab');
        },
        goHistory: function()
        {
            this.$emit('goHistory')
        }

    }
}
</script>

<style scoped>
    .delivery {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    .image {
        width: 100%;
    }
    .bottom {
        bottom: calc(100vw * 120 / 375);
        position: fixed; 
        width: calc(100% - 12.4px);
        display: flex;
        flex-direction: column;
    }
        .wrapper {
        position: relative;
        width: 100%;
    }
 .button1 {
        position: absolute;
        width: 20%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 18%;
        aspect-ratio: 2/1.3;
        top: 0;
        left: 20%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 15%;
        aspect-ratio: 2/1.6;
        top: 0;
        left: 38%;
        z-index: 1;
    }
     .button4 {
        position: absolute;
        width: 21%;
        aspect-ratio: 2/1.1;
        top: 0;
        left: 53%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/DeliveryPharmacy.vue